import React from 'react';
import { SidebarPortal, BlockDataForm } from '@plone/volto/components';
import View from './View';
import MostReadSchema from './schema';

const Edit = (props) => {
  const { selected, onChangeBlock, block, data } = props;
  const schema = MostReadSchema();

  return (
    <>
      <View {...props} />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          onChangeField={(id, value) =>
            onChangeBlock(block, { ...data, [id]: value })
          }
          formData={data}
          block={block}
        />
      </SidebarPortal>
    </>
  );
};

export default Edit;
